import Keycloak from 'keycloak-js';
import { keycloakSettings } from 'utils/environment/configuration';

export const keycloakSetting = {
    url: keycloakSettings.url,
    realm: keycloakSettings.realm,
    clientId: keycloakSettings.clientId
};

export const createKeycloakClient = () => new Keycloak(keycloakSetting);

const keycloak = createKeycloakClient();

export default keycloak;
